import { Option } from '@/types/option';
import BaseStore from './BaseStore';
import { ResponseData } from '@/types/http';
import { OptionApi } from '@/apis';
import RootStore from '.';
import { flow, makeObservable, observable } from 'mobx';
import { GetOptionsEnduserResponse, GetOptionsRequest, GetOptionsResponse, PostOptionRequest } from '@/types/http-payload/option';
import { TableState } from '@tanstack/react-table';

export default class OptionStore extends BaseStore {
    options: Option[] = [];
    optionsForOrder: GetOptionsEnduserResponse = {} as GetOptionsEnduserResponse;
    api: OptionApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            options: observable,
            optionsForOrder: observable,
            getOptions: flow.bound,
            getOptionsEnduser: flow.bound,
            createOption: flow.bound,
            getOptionById: flow.bound,
            updateOption: flow.bound,
            deleteOption: flow.bound
        });
        this.api = new OptionApi();
    }

    *getOptions(request: GetOptionsRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...request, sortDir: 'ASC', sortKey: 'format' };
            const res: ResponseData<GetOptionsResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getOptions, payload);
            if (res.ok) {
                this.options = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
            }
        } catch (error) {
        }
    }

    *getOptionsEnduser(request: GetOptionsRequest) {
        try {
            const res: ResponseData<GetOptionsEnduserResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getOptionsEnduser, request);
            if (res.ok) {
                this.optionsForOrder = res.data;
                return res.data;
            }
        } catch (error) {
        }
    }

    *createOption(payload: PostOptionRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.createOption, payload);
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *getOptionById(optionId: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getOptionById, optionId);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
        }
    }

    *updateOption(optionId: string | number, payload: PostOptionRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateOption, { optionId, payload });
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *deleteOption(optionId: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteOption, optionId);
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();
        this.options = [];
    }
}
